import React from "react";
import { motion } from "framer-motion";

import gameConstants from "../../constants/game";
import { useSelector } from "react-redux";
import ProgressRow from "./ProgressRow";
import { climates } from "../../constants/capitals";

const GuessCapitalRow = ({ name, category, climate }) => {
  const { capital } = useSelector(({ game }) => game.countryOfToday);

  return (
    <div className="relative col-span-7 grid h-fit grid-cols-7 gap-1">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2 }}
        className={`col-span-7 grid h-full grid-cols-7 gap-1`}
      >
        <div className="animate-reveal col-span-1 flex h-full items-center justify-center rounded border-2 px-2">
          <img
            alt={name}
            src={
              category !== ""
                ? `/images/city/${category}.svg`
                : `/images/city/${climates[climate]}.svg`
            }
            className="h-6 w-6"
          />
        </div>

        <div className="animate-reveal col-span-5 flex h-full items-center justify-center rounded border-2 px-2">
          {name}
        </div>
        <div className="animate-reveal col-span-1 flex h-full items-center justify-center rounded border-2 px-2">
          <img
            alt={gameConstants.yesOrNo[name === capital.name ? 1 : 0].imgAlt}
            src={gameConstants.yesOrNo[
              name === capital.name ? 1 : 0
            ].imgSrc?.toLowerCase()}
            className="h-4 w-4"
          />
        </div>
      </motion.div>
      <ProgressRow />
    </div>
  );
};

export default GuessCapitalRow;
